import { Button, HStack, Modal, ModalBody, ModalCloseButton, ModalContent, ModalFooter, ModalHeader, ModalOverlay, Text, useToast } from '@chakra-ui/react'
import { useRef, useState } from 'react'
import { closeDeleteModal } from 'src/redux/features/languages/languageSlice'
import { useAppDispatch, useAppSelector } from 'src/redux/hooks'
import { deleteLanguage } from 'src/view-models/Languages'

const DeleteModal = () => {
    const dispatch = useAppDispatch()
    const toast = useToast()
    const {isOpenDelete,languageId} = useAppSelector((state)=>state.language)
    const finalRef = useRef(null)
    const [isDeleting,setIsDeleting] = useState(false)

    const handleDelete = async () => {
      setIsDeleting(true)
        const response = await deleteLanguage(languageId!,toast,dispatch)
        if(response.status === true) {
          handleClose()
        } 
        setIsDeleting(false)

      }

    const handleClose = () => {
        dispatch(closeDeleteModal())
    }

  return (
    <Modal finalFocusRef={finalRef} isOpen={isOpenDelete} onClose={handleClose}>
        <ModalOverlay 
        />
        <ModalContent>
          <ModalHeader>Suprimer la langue</ModalHeader>
          <ModalCloseButton />
          <ModalBody>
            <Text>Êtes-vous sûr de vouloir supprimer <span className='font-bold' ></span> cette langue??</Text>
          </ModalBody>
          <ModalFooter >
            <HStack gap={4} >
              <Button disabled={isDeleting} colorScheme='red' onClick={handleDelete}>Suprimer</Button>
              <Button disabled={isDeleting} colorScheme='blue' mr={3} onClick={handleClose}>
                Fermer
              </Button>
            </HStack>
          </ModalFooter>
        </ModalContent>
      </Modal>
  )
}

export default DeleteModal